// 学习进度相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 学习进度API接口类
 */
export class ProgressAPI {
  /**
   * 获取用户学习统计
   * @returns {Promise} API响应
   */
  static async getStatistics() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PROGRESS.GET_STATISTICS);
      return {
        success: true,
        data: response.data || response,
        message: "获取学习统计成功",
      };
    } catch (error) {
      console.error("获取学习统计失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取学习统计失败",
      };
    }
  }

  /**
   * 获取待复习单词列表
   * @returns {Promise} API响应
   */
  static async getReviewList() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PROGRESS.GET_REVIEW_LIST);
      return {
        success: true,
        data: response.data || response,
        message: "获取复习列表成功",
      };
    } catch (error) {
      console.error("获取复习列表失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取复习列表失败",
      };
    }
  }

  /**
   * 提交复习结果
   * @param {Object} reviewData - 复习数据
   * @returns {Promise} API响应
   */
  static async submitReview(reviewData) {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.PROGRESS.SUBMIT_REVIEW,
        reviewData
      );
      return {
        success: true,
        data: response.data || response,
        message: "提交复习结果成功",
      };
    } catch (error) {
      console.error("提交复习结果失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "提交复习结果失败",
      };
    }
  }

  /**
   * 获取每日学习总结
   * @param {number} userId - 用户ID
   * @param {string} date - 日期 (YYYY-MM-DD)
   * @returns {Promise} API响应
   */
  static async getDailySummary(userId, date) {
    try {
      const params = { userId, date };
      const response = await apiClient.get(
        API_ENDPOINTS.PROGRESS.GET_DAILY_SUMMARY,
        { params }
      );
      return {
        success: true,
        data: response.data || response,
        message: "获取每日总结成功",
      };
    } catch (error) {
      console.error("获取每日总结失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取每日总结失败",
      };
    }
  }

  /**
   * 获取学习报告
   * @param {number} userId - 用户ID
   * @param {Object} params - 查询参数
   * @returns {Promise} API响应
   */
  static async getLearningReport(userId, params = {}) {
    try {
      const queryParams = { userId, ...params };
      const response = await apiClient.get(
        API_ENDPOINTS.PROGRESS.GET_LEARNING_REPORT,
        { params: queryParams }
      );
      return {
        success: true,
        data: response.data || response,
        message: "获取学习报告成功",
      };
    } catch (error) {
      console.error("获取学习报告失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取学习报告失败",
      };
    }
  }

  /**
   * 更新单词学习阶段
   * @param {number} userId - 用户ID
   * @param {number} wordId - 单词ID
   * @param {number} stage - 新阶段
   * @returns {Promise} API响应
   */
  static async updateStage(userId, wordId, stage) {
    try {
      const data = { userId, wordId, stage };
      const response = await apiClient.put(
        API_ENDPOINTS.PROGRESS.UPDATE_STAGE,
        data
      );
      return {
        success: true,
        data: response.data || response,
        message: "更新阶段成功",
      };
    } catch (error) {
      console.error("更新阶段失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "更新阶段失败",
      };
    }
  }
}

export default ProgressAPI;
